// extracted by mini-css-extract-plugin
export default {"heading":"Ws-z","corrected":"Xs-z","redirectVerbiageContainer":"Ys-z","redirectVerbiageText":"Zs-z"};